<template>
  <div class="content--sinoreg">
    <header-blue>
      <h4>Impressos de Segurança</h4>
    </header-blue>
    <b-tabs align="left"
            class="Resumo-border"
            active-nav-item-class="Resumo--tab-active">
      <b-tab>
        <template v-slot:title>
          Administração de lotes
        </template>

        <router-view />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  /* components */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"

  export default {
    name: "PapelSeguranca",
    components: {
      HeaderBlue
    }
  }
</script>

<style scoped>

</style>
